import { baseQuestSchema } from './admin';
export const getAdminQuestSchema = baseQuestSchema;
